<script>
  import { Router, Route, Link, navigate } from "svelte-routing";
  import Main from "./Main.svelte";
  import Login from "./Login.svelte";
  import PasswordReset from "./PasswordReset.svelte";
  import ErrorBar from "./components/ErrorBar.svelte";

  export let url = "";

  window.initMaps = () => {
    const myEvent = new CustomEvent("maps-loaded");
    window.dispatchEvent(myEvent);
  };
</script>

<svelte:head>
  <script
    src="https://maps.googleapis.com/maps/api/js?key=MAPS_API_KEY&libraries=places&callback=initMaps"
    async
    defer>

  </script>
</svelte:head>

<Router {url}>
  <div>
    <Route path="/login" component={Login} />
    <Route path="/password-reset/:verification_code" component={PasswordReset} />
    <Route path="/*" component={Main} />
  </div>
</Router>
<ErrorBar />
